// #WEEKNUM_V1 — one definition of "what week is it" for the whole app.
// ISO-8601: weeks run Monday–Sunday, and week 1 is the week containing the first Thursday
// of January. That's the standard payroll/reporting convention and it's what makes
// 07/20/2026–07/26/2026 come out as WK 30.
//
// Edge cases this handles correctly (they are the reason to have one shared copy):
//   • 2025-12-29 (Mon) -> WK 1   — belongs to 2026, not week 53 of 2025
//   • 2027-01-01 (Fri) -> WK 53  — belongs to 2026, not week 1 of 2027
// Use isoWeekYear() alongside isoWeek() whenever you store or group by week, so those
// year-boundary weeks don't collide across years.

/** ISO week number (1–53) for a Date. */
export const isoWeek = (d) => {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = t.getUTCDay() || 7;          // Sunday = 7, not 0
  t.setUTCDate(t.getUTCDate() + 4 - day);  // move to the Thursday of this week
  const y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
  return Math.ceil(((t - y0) / 86400000 + 1) / 7);
};

/** The year that ISO week belongs to (may differ from the calendar year in late Dec / early Jan). */
export const isoWeekYear = (d) => {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - day);
  return t.getUTCFullYear();
};

/** Monday 00:00 of the week containing d. */
export const mondayOf = (d) => {
  const x = new Date(d); const back = (x.getDay() + 6) % 7;
  x.setDate(x.getDate() - back); x.setHours(0, 0, 0, 0); return x;
};

/** "WK 30" — the label to show in headers. */
export const wkLabel = (d) => `WK ${isoWeek(d)}`;

/** "2026-W30" — stable sortable key for grouping/storing by week. */
export const wkKey = (d) => `${isoWeekYear(d)}-W${String(isoWeek(d)).padStart(2, '0')}`;
